export const IMAGE_COMPRESSION = {
  SPEED: { MAX_SIZE: 1024, QUALITY: 0.7 },
  ACCURACY: { MAX_SIZE: 2048, QUALITY: 0.9 },
  MAX_IMAGES: 2,
};

export const BATCH_CONCURRENCY = 8;

export const DEPARTMENT_OPTIONS = ['', '青果', '精肉', '鮮魚', '惣菜', 'ベーカリー'];

export const IMAGE_MODE_LABEL = { speed: '⚡速度', accuracy: '🔍精度' };
export const IMAGE_MODE_STYLE = { speed: 'bg-amber-100 text-amber-700', accuracy: 'bg-sky-100 text-sky-700' };
export const FEEDBACK_LABEL = { correct: '👍 正しい', incorrect: '👎 誤検知', uncertain: '❓ 不明' };
export const FEEDBACK_STYLE = { correct: 'bg-green-100 text-green-700', incorrect: 'bg-red-100 text-red-700', uncertain: 'bg-slate-100 text-slate-500' };
